// https://malcoded.com/posts/angular-reactive-form-validation/
// using custom validator (mostly for reactive form)

import { AbstractControl } from '@angular/forms';

export function phoneNumberValidator(control: AbstractControl): { [key: string]: any } | null {
  const valid = /^\d+$/.test(control.value);
  return valid ? null : { invalidNumber: { valid: false, value: control.value } };
}
